import React, {useState} from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {AccordionSummary, Typography} from "@material-ui/core";
import {ExpansionPanel, ExpansionPanelDetails} from "../../../../../../../../Utils/ExpansionPanel";
import withStyles from "@material-ui/core/styles/withStyles";

const CollapsedFields = ({label, children}) => {
    const [expanded, setExpanded] = useState(false)
    return (
        <div style={{padding: '5px 0'}}>
            <ExpansionPanel expanded={expanded}
                            onClick={(e) => {
                                e.stopPropagation();
                                setExpanded(!expanded)
                            }}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon/>}
                >
                    <Typography style={{textTransform: "capitalize"}}>{label}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails
                    onClick={e => e.stopPropagation()}>
                    {children}
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </div>
    )
}
export default CollapsedFields

const ExpansionPanelSummary = withStyles({
    root: {
        backgroundColor: "rgba(0,0,0,.0150)",
        borderBottom: "1px solid rgba(0,0,0,.125)",
        marginBottom: -1,
        padding: '0 24px 0 8px',
        minHeight: 28,
        "&$expanded": {
            minHeight: 28,
        }
    },
    expandIcon: {
        padding: 0
    },
    content: {
        margin: "0 0",
        '&>p': {
            fontSize: '0.875rem'
        },
        "&$expanded": {
            margin: "8px 0",
        }
    },
    expanded: {
    }
})(props => <AccordionSummary {...props} />);